export default {
  confirm: 'Conferma',
  title: 'Offerte disponibili',
};
